import { BridgeComponent } from "@hotwired/hotwire-native-bridge"

export default class extends BridgeComponent {
  static component = "button"
  static values = {
    title: String,
    icon: { type: String, default: "" },
    style: { type: String, default: "default" }
  }

  connect() {
    super.connect()
    this.send("connect", {
      title: this.titleValue,
      icon: this.iconValue,
      style: this.styleValue
    }, () => {
      this.element.click()
    })
  }
}
